import CannedBeans from 'views/Legumes/CannedBeans/CannedBeans'
import DryBeans from 'views/Legumes/DryBeans/DryBeans'
import DriedFruits from 'views/FruitsAndVegs/DriedFruits/DriedFruits'
import CannedFish from 'views/CannedFish/CannedFish'
import CannedVegsFruits from 'views/FruitsAndVegs/CannedVegsFruits/CannedVegsFruits'
import FrozenVegsFruits from 'views/FruitsAndVegs/FrozenVegsFruits/FrozenVegsFruits'
import BottledJuice from 'views/Juices/BottledJuice'
import Cheese from 'views/Cheese/Cheese'
import Eggs from 'views/Eggs/Eggs'
import PeanutButter from 'views/Legumes/PeanutButter/PeanutButter'
import WholeMilk from 'views/Milk/WholeMilk/WholeMilk'
import FatReducedMilk from 'views/Milk/FatReducedMilk/FatReducedMilk'
import Bread from 'views/WholeGrains/Bread/Bread'
import Barley from 'views/WholeGrains/Barley/Barley'
import Bulgur from 'views/WholeGrains/Bulgur/Bulgur'
import OatsOatmeal from 'views/WholeGrains/OatsOatmeal/OatsOatmeal'
import BrownRice from 'views/WholeGrains/BrownRice/BrownRice'
import InfantMeats from 'views/Infant/Meats/InfantMeats'
import InfantFruitsAndVegs from 'views/Infant/FruitsAndVegs/InfantFruitsAndVegs'
import BSCornTortilla from 'views/BSWholeGrains/CornTortilla/CornTortilla'
import BSWheatTortilla from 'views/BSWholeGrains/WheatTortilla/WheatTortilla'
import BSWheatPasta from 'views/BSWholeGrains/WheatPasta/WheatPasta'
import PlantMilk from 'views/BrandSpecific/PlantMilk/PlantMilk'
import Tofu from 'views/Tofu/Tofu'
import Yogurt from 'views/Yogurt/Yogurt'
import BSInfantMeats from 'views/BrandSpecific/Infant/Meats/BSInfantMeats'
import BSInfantCereal from 'views/BrandSpecific/Infant/Cereal/BSInfantCereal'
import BSInfantFruitsAndVegs from 'views/BrandSpecific/Infant/FruitsAndVegs/BSInfantFruitsAndVegs'
import BSBreakfastCereal from 'views/BrandSpecific/BreakfastCereal/BreakfastCereal/BreakfastCereal'
import BSInstantOatmeal from 'views/BrandSpecific/BreakfastCereal/InstantOatmeal/InstantOatmeal'
import RFIInfantMeats from 'views/BrandSpecific/RFIInfant/Meats/RFIInfantMeats'
import RFIInfantFruitsAndVegs from 'views/BrandSpecific/RFIInfant/FruitsAndVegs/RFIInfantFruitsAndVegs'
import PlantYogurt from 'views/BrandSpecific/PlantYogurt/PlantYogurt'
import PlantCheese from 'views/BrandSpecific/PlantCheese/PlantCheese'
import NutSeedButters from 'views/BrandSpecific/NutSeedButters/NutSeedButters'
import BSWholeWheatBagels from 'views/BrandSpecific/WholeGrains/BSWholeWheatBagels/BSWholeWheatBagels'
import BSQuinoa from 'views/BrandSpecific/WholeGrains/BSQuinoa/BSQuinoa'
import BSWholeWheatEnglishMuffins from 'views/BrandSpecific/WholeGrains/BSWholeWheatEnglishMuffins/BSWholeWheatEnglishMuffins'
import BSWholeWheatNaan from 'views/BrandSpecific/WholeGrains/BSWholeWheatNaan/BSWholeWheatNaan'
import BSWholeWheatPitaBread from 'views/BrandSpecific/WholeGrains/BSWholeWheatPitaBread/BSWholeWheatPitaBread'
import BSWildRice from 'views/BrandSpecific/WholeGrains/BSWildRice/BSWildRice'
import BSCornMasaFlour from 'views/BrandSpecific/WholeGrains/BSCornMasaFlour/BSCornMasaFlour'
import BSCornmeal from 'views/BrandSpecific/WholeGrains/BSCornmeal/BSCornmeal'
import BSOatsOatmeal from 'views/BrandSpecific/WholeGrains/BSOatsOatmeal/BSOatsOatmeal'
import WWBagels from 'views/WWBagels/WWBagels'
import WWMuffins from 'views/WWMuffins/WWMuffins'
import WWPitaBread from 'views/WWPitaBread/WWPitaBread'
import WGCornmeal from 'views/WGCornmeal/WGCornmeal'
import CornMasaFlour from 'views/CornMasaFlour/CornMasaFlour'
import CornTortilla from 'views/WholeGrains/CornTortilla/CornTortilla'
import WheatTortilla from 'views/WholeGrains/WheatTortilla/WheatTortilla'
import WheatPasta from 'views/WholeGrains/WheatPasta/WheatPasta'
import Dashboard from 'views/pages/Dashboard'
import MyProfile from 'views/pages/MyProfile'

// import LogoutPage from 'views/pages/LogoutPage'

const submissionRoutes = [
  {
    path: '/dashboard',
    name: 'Home',
    // icon: 'fas fa-home',
    component: Dashboard,
    layout: '/submission',
  },

  {
    path: '/eggs',
    name: 'Cage Free Eggs',
    // icon: 'far fa-circle',
    component: Eggs,
    layout: '/submission',
  },
  {
    path: '/my-profile',
    name: 'My Profile',
    // icon: 'far fa-circle',
    component: MyProfile,
    layout: '/submission',
  },
  {
    path: '/canned-fish',
    name: 'Canned Fish',
    // icon: 'far fa-circle',
    component: CannedFish,
    layout: '/submission',
  },
  {
    path: '/cheese',
    name: 'Cheese',
    component: Cheese,
    // icon: 'far fa-circle',
    layout: '/submission',
  },
  {
    collapse: true,
    name: 'Fruits & Vegetables',
    // icon: 'far fa-circle',
    state: 'fruitsCollapse',
    views: [
      {
        path: '/vegs-fruits-canned',
        name: 'Canned Fruits/Vegetables',
        // mini: 'far fa-circle fa-fw',
        component: CannedVegsFruits,
        layout: '/submission',
      },
      {
        path: '/dried-fruits',
        name: 'Dried Fruits',
        // mini: 'far fa-circle fa-fw',
        component: DriedFruits,
        layout: '/submission',
      },
      {
        path: '/vegs-fruits-frozen',
        name: 'Frozen Fruits/Vegetables',
        // mini: 'far fa-circle fa-fw',
        component: FrozenVegsFruits,
        layout: '/submission',
      },
    ],
  },
  {
    path: '/infant-meats',
    name: 'Infant Meats',
    // icon: 'far fa-circle',
    component: InfantMeats,
    layout: '/submission',
  },
  {
    path: '/infant-fruits-vegs',
    name: 'Infant Fruits and Vegetables',
    // icon: 'far fa-circle',
    component: InfantFruitsAndVegs,
    layout: '/submission',
  },
  {
    path: '/juice-bottled',
    name: 'Juice',
    // icon: 'far fa-circle',
    component: BottledJuice,
    layout: '/submission',
  },
  {
    collapse: true,
    name: 'Legumes',
    // icon: 'far fa-circle',
    state: 'legumesCollapse',
    views: [
      {
        path: '/canned-beans',
        name: 'Canned Mature Beans',
        // mini: 'far fa-circle',
        component: CannedBeans,
        layout: '/submission',
      },
      {
        path: '/dry-beans',
        name: 'Dry Beans/Peas/Lentils',
        // mini: 'far fa-circle',
        component: DryBeans,
        layout: '/submission',
      },
      {
        path: '/peanut-butter',
        name: 'Peanut Butter',
        // mini: 'far fa-circle',
        component: PeanutButter,
        layout: '/submission',
      },
    ],
  },
  {
    collapse: true,
    name: 'Milk',
    // icon: 'far fa-circle',
    state: 'milkCollapse',
    views: [
      {
        path: '/fat-reduced',
        name: 'Fat Reduced',
        // mini: 'far fa-circle',
        component: FatReducedMilk,
        layout: '/submission',
      },
      {
        path: '/whole-milk',
        name: 'Whole Milk',
        // mini: 'far fa-circle',
        component: WholeMilk,
        layout: '/submission',
      },
    ],
  },
  {
    collapse: true,
    name: 'Whole Grains',
    // icon: 'far fa-circle',
    state: 'grainsCollapse',
    views: [
      {
        path: '/brown-rice',
        name: 'Brown Rice',
        // mini: 'far fa-circle',
        component: BrownRice,
        layout: '/submission',
      },
      {
        path: '/bulgur',
        name: 'Bulgur',
        // mini: 'far fa-circle',
        component: Bulgur,
        layout: '/submission',
      },
      {
        path: '/corn-masa-flour',
        name: 'Corn Masa Flour',
        // icon: 'far fa-circle',
        component: CornMasaFlour,
        layout: '/submission',
      },
      {
        path: '/corn-tortilla',
        name: 'Corn Tortillas (soft)',
        // icon: 'far fa-circle',
        component: CornTortilla,
        layout: '/submission',
      },
      {
        path: '/oats-oatmeal',
        name: 'Oats/Oatmeal',
        // mini: 'far fa-circle',
        component: OatsOatmeal,
        layout: '/submission',
      },
      {
        path: '/barley',
        name: 'Whole Grain Barley (No Pearl)',
        // mini: 'far fa-circle',
        component: Barley,
        layout: '/submission',
      },
      {
        path: '/whole-grain-cornmeal',
        name: 'Whole Grain Cornmeal',
        // icon: 'far fa-circle',
        component: WGCornmeal,
        layout: '/submission',
      },
      {
        path: '/whole-wheat-bagels',
        name: 'Whole Wheat Bagels',
        // icon: 'far fa-circle',
        component: WWBagels,
        layout: '/submission',
      },
      {
        path: '/bread',
        name: 'Whole Wheat Bread',
        // mini: 'far fa-circle',
        component: Bread,
        layout: '/submission',
      },
      {
        path: '/whole-wheat-english-muffins',
        name: 'Whole Wheat English Muffins',
        // icon: 'far fa-circle',
        component: WWMuffins,
        layout: '/submission',
      },
      {
        path: '/whole-wheat-pasta',
        name: 'Whole Wheat Pasta',
        // icon: 'far fa-circle',
        component: WheatPasta,
        layout: '/submission',
      },
      {
        path: '/whole-wheat-pita-bread',
        name: 'Whole Wheat Pita Bread',
        // icon: 'far fa-circle',
        component: WWPitaBread,
        layout: '/submission',
      },
      {
        path: '/whole-wheat-tortillas',
        name: 'Whole Wheat Tortillas',
        // icon: 'far fa-circle',
        component: WheatTortilla,
        layout: '/submission',
      },
    ],
  },
  {
    path: null,
    name: 'Brand Specific',
    // icon: 'fas fa-ban',
    component: null,
    layout: '/submission',
    header: true,
  },
  {
    collapse: true,
    name: 'Breakfast Cereal',
    // icon: 'far fa-circle',
    state: 'breakfastCerealCollapse',
    views: [
      {
        path: '/brandspecific/breakfastcereal/breakfast-cereal',
        name: 'Whole Grain Breakfast Cereal',
        // mini: 'far fa-circle',
        component: BSBreakfastCereal,
        layout: '/submission',
      },
      {
        path: '/brandspecific/breakfastcereal/instant-oatmeal',
        name: 'Whole Grain Instant Oatmeal',
        // mini: 'far fa-circle',
        component: BSInstantOatmeal,
        layout: '/submission',
      },
    ],
  },
  {
    collapse: true,
    name: 'Infant Food Brands',
    // icon: 'far fa-circle',
    state: 'infantFoodsCollapse',
    views: [
      {
        path: '/brandspecific/infant-cereal',
        name: 'Infant Cereal',
        // icon: 'fas fa-ban',
        component: BSInfantCereal,
        layout: '/submission',
      },
      {
        path: '/brandspecific/infant-fruit-and-vegetables',
        name: 'Infant Fruits & Vegetables',
        // icon: 'fas fa-ban',
        component: BSInfantFruitsAndVegs,
        layout: '/submission',
      },
      {
        path: '/brandspecific/infant-meats',
        name: 'Infant Meats',
        // icon: 'fas fa-ban',
        component: BSInfantMeats,
        layout: '/submission',
      },
    ],
  },
  {
    path: '/brandspecific/nut-and-seed-butters',
    name: 'Other Nut and Seed Butters',
    // icon: 'fas fa-ban',
    component: NutSeedButters,
    layout: '/submission',
  },
  {
    path: '/brandspecific/plant-based-cheese-alternatives',
    name: 'Plant-Based Cheese Alternatives',
    // icon: 'fas fa-ban',
    component: PlantCheese,
    layout: '/submission',
  },
  {
    path: '/brandspecific/plant-based-milk-alternatives',
    name: 'Plant-Based Milk Alternatives',
    // icon: 'fas fa-ban',
    component: PlantMilk,
    layout: '/submission',
  },
  {
    path: '/brandspecific/plant-based-yogurt-alternatives',
    name: 'Plant-Based Yogurt Alternatives',
    // icon: 'fas fa-ban',
    component: PlantYogurt,
    layout: '/submission',
  },
  {
    path: '/tofu',
    name: 'Tofu',
    // icon: 'fas fa-ban',
    component: Tofu,
    layout: '/submission',
  },
  {
    collapse: true,
    name: 'Whole Grains',
    // icon: 'far fa-circle',
    state: 'brandSpecificWholeGrainCollapse',
    views: [
      {
        path: '/brandspecific/corn-masa-flour',
        name: 'Corn Masa Flour',
        // mini: 'far fa-circle',
        component: BSCornMasaFlour,
        layout: '/submission',
      },
      {
        path: '/brandspecific/corn-tortillas-soft',
        name: 'Corn Tortillas (Soft)',
        // mini: 'far fa-circle',
        component: BSCornTortilla,
        layout: '/submission',
      },
      {
        path: '/brandspecific/cornmeal',
        name: 'Cornmeal',
        // mini: 'far fa-circle',
        component: BSCornmeal,
        layout: '/submission',
      },
      {
        path: '/brandspecific/oats-oatmeal',
        name: 'Oats/Oatmeal',
        // mini: 'far fa-circle',
        component: BSOatsOatmeal,
        layout: '/submission',
      },
      {
        path: '/brandspecific/quinoa',
        name: 'Quinoa',
        // mini: 'far fa-circle',
        component: BSQuinoa,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-bagels',
        name: 'Whole Wheat Bagels',
        // mini: 'far fa-circle',
        component: BSWholeWheatBagels,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-english-muffins',
        name: 'Whole Wheat English Muffins',
        // mini: 'far fa-circle',
        component: BSWholeWheatEnglishMuffins,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-naan',
        name: 'Whole Wheat Naan',
        // mini: 'far fa-circle',
        component: BSWholeWheatNaan,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-pasta',
        name: 'Whole Wheat Pasta',
        // mini: 'far fa-circle',
        component: BSWheatPasta,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-pita-bread',
        name: 'Whole Wheat Pita Bread',
        // mini: 'far fa-circle',
        component: BSWholeWheatPitaBread,
        layout: '/submission',
      },
      {
        path: '/brandspecific/whole-wheat-tortillas',
        name: 'Whole Wheat Tortillas',
        // mini: 'far fa-circle',
        component: BSWheatTortilla,
        layout: '/submission',
      },
      {
        path: '/brandspecific/wild-rice',
        name: 'Wild Rice',
        // mini: 'far fa-circle',
        component: BSWildRice,
        layout: '/submission',
      },
    ],
  },
  {
    path: '/yogurt',
    name: 'Yogurt',
    // icon: 'far fa-circle',
    component: Yogurt,
    layout: '/submission',
  },
  {
    collapse: true,
    name: '2025 RFI Infant Foods',
    // icon: 'far fa-circle',
    state: 'brandSpecific2025RFIInfantFoods',
    views: [
      {
        path: '/2025-rfi-infant-meats',
        name: '2025 RFI Infant Meats',
        // mini: 'far fa-circle',
        component: RFIInfantMeats,
        layout: '/submission',
      },
      {
        path: '/2025-rfi-infant-fruits-vegs',
        name: '2025 RFI Infant F & V',
        // mini: 'far fa-circle',
        component: RFIInfantFruitsAndVegs,
        layout: '/submission',
      },
    ],
  },
]

export default submissionRoutes
